import { createFileRoute, redirect } from "@tanstack/react-router";
import { useSession } from "@/lib/auth/session";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/login")({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated()) {
      throw redirect({ to: "/" });
    }
  },
  component: LoginPage,
});

function LoginPage() {
  const session = useSession();

  if (session.error) {
    return (
      <CenteredCard>
        <p className="text-destructive">Anmeldefehler: {session.error.message}</p>
        <Button onClick={() => void session.signin()} className="mt-4">
          Erneut versuchen
        </Button>
      </CenteredCard>
    );
  }

  return (
    <CenteredCard>
      <h1 className="text-2xl font-semibold tracking-tight">Javeed</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Anmeldung über Keycloak. Du wirst weitergeleitet.
      </p>
      <Button className="mt-6 w-full" onClick={() => void session.signin()}>
        Anmelden
      </Button>
    </CenteredCard>
  );
}

function CenteredCard({ children }: { children: React.ReactNode }) {
  return (
    <div className="grid min-h-screen place-items-center bg-muted/30 p-6">
      <div className="w-full max-w-sm rounded-lg border bg-card p-8 shadow-sm">{children}</div>
    </div>
  );
}
